import { useMutation, useQueryClient } from '@tanstack/react-query'
import { notificationsApi } from '../api/notificationsApi'

export const useDeleteNotification = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => notificationsApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] })
    },
  })
}
